import { render, staticRenderFns } from "./GroupTypeCustomFieldRow.vue?vue&type=template&id=52fd83a0&"
import script from "./GroupTypeCustomFieldRow.vue?vue&type=script&lang=js&"
export * from "./GroupTypeCustomFieldRow.vue?vue&type=script&lang=js&"
import style0 from "./GroupTypeCustomFieldRow.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports